import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Route guard for a gated surface.
 *
 * Wraps a route element and takes a predicate; anyone the predicate refuses is
 * sent to the V3 landing page instead. PrivateRoute above it has already
 * established that SOMEBODY is signed in — this only asks what their client has
 * switched on.
 *
 * A predicate rather than a role string, because the gates it enforces are not
 * about roles at all: the Digital Twin turns on a concessionaire-level
 * entitlement, already expressed as one function in hooks/useAuth. Passing the
 * check itself keeps that the single definition.
 *
 * The matching menu items are hidden in V3Sidebar. Both are needed: hiding a
 * link removes it from view, and this removes it from reach.
 */
export default function RequireAccess({ allow, children }) {
    if (typeof allow === 'function' ? allow() : !!allow) return children;
    return <Navigate to={`${process.env.PUBLIC_URL}/v3/spatial`} replace />;
}
